import { useMemo, useState } from "react";
import { animeList, dayTabs } from "@/mocks/anime";

export default function WeeklyNew() {
  const [activeDay, setActiveDay] = useState("全部");

  const list = useMemo(() => {
    if (activeDay === "全部") return animeList;
    return animeList.filter((item) => item.day === activeDay);
  }, [activeDay]);

  return (
    <section id="weekly" className="bg-background-100">
      <div className="mx-auto max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
        <div className="max-w-2xl">
          <span className="text-sm font-medium text-primary-600">本周新番</span>
          <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-3xl">
            按播出日查看当季新番排期
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
            下面的新番按周一至周日的固定播出日归类。切换到对应日期，就能看到当天更新的作品、题材与更新到的集数，方便提前安排追番时间。
          </p>
        </div>

        <div className="mt-6 flex flex-wrap gap-2">
          {dayTabs.map((day) => (
            <button
              key={day}
              type="button"
              onClick={() => setActiveDay(day)}
              className={`rounded-full px-4 py-2 text-sm transition-colors ${
                activeDay === day
                  ? "bg-primary-500 text-background-50"
                  : "border border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-700"
              }`}
            >
              {day}
            </button>
          ))}
        </div>

        <p className="mt-5 text-xs text-foreground-600">
          当前筛选：<span className="text-foreground-900">{activeDay}</span> · 共 {list.length} 部作品
        </p>

        <div className="mt-4 grid grid-cols-1 gap-3 md:grid-cols-2 md:gap-4">
          {list.map((item) => (
            <article
              key={item.id}
              className="flex gap-3 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300 md:gap-4 md:p-4"
            >
              <div className="h-24 w-[68px] shrink-0 overflow-hidden rounded-md md:h-28 md:w-20">
                <img src={item.cover} alt={`${item.title} 封面`} className="h-full w-full object-cover object-top" />
              </div>
              <div className="flex min-w-0 flex-1 flex-col">
                <div className="flex items-start justify-between gap-2">
                  <h3 className="truncate text-sm font-medium text-foreground-950 md:text-base">{item.title}</h3>
                  <span className="shrink-0 rounded-md bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900">
                    {item.day}
                  </span>
                </div>
                <p className="mt-1 text-xs text-foreground-600">
                  {item.genres.join(" · ")} · {item.year}
                </p>
                <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-700">{item.summary}</p>
                <div className="mt-auto flex items-center justify-between pt-2 text-xs">
                  <span className="text-foreground-700">
                    更新至 <span className="font-medium text-primary-700">第 {item.latest} 话</span> / 共 {item.total} 话
                  </span>
                  <span className="flex items-center gap-1 text-accent-700">
                    <i className="ri-star-fill"></i>
                    {item.score}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}